import Axios from "axios";
import {
    SET_BUDGET_LIST,
    UNSET_BUDGET_LIST,
} from "@/store/mutation-types";
import { 
    budgetResource,
    budgetReviseResource,
} from "@/store/api";

const state = {
    getBudgetList: [],
};

const getters = {
    getBudgetList(state) {
        return state.getBudgetList;
    },
};

const mutations = {
    [SET_BUDGET_LIST](state, data) {
        state.getBudgetList = data;
    },
    [UNSET_BUDGET_LIST](state) {
        state.getBudgetList = [];
    },
};

const actions = {
    saveBudget({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(budgetResource, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateBudget({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${budgetResource}/${data.id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getBudgetList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(budgetResource)
            .then(function (response) {
            commit('SET_BUDGET_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_BUDGET_LIST');
            reject(error);
            });
        });
    },

    getBudgetById({ commit }, data) {
        const getBudgetRecordById = `${budgetResource}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getBudgetRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },

    reviseBudget({ commit }, {id, data}) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(budgetReviseResource(id), data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },


};

export default {
  state,
  getters,
  actions,
  mutations,
};

